// La collection ne sait stocker que six jours : `sunday` n'a pas d'équivalent et l'API le rejette.
// Ce type ne vaut que pour l'ÉCRITURE ; à la lecture, `DeliveryPointSchedule.day` reste `string`
// pour rester tolérant aux documents historiques.
export const STORABLE_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;

export type StorableDay = typeof STORABLE_DAYS[number];
